import { fetchApi } from '@/services/api-client';

export const SAND_DOLLAR_AWARDS_PATH = '/sand-dollar-awards';

export type SandDollarAward = {
  id: string;
  studentId: string;
  studentDisplayName: string | null;
  studentGradeLevel: number | null;
  studentHouseId: string | null;
  studentHouseName: string | null;
  categoryId: string;
  categoryName: string | null;
  categoryColor: string | null;
  teacherUserId: string | null;
  teacherEmail: string | null;
  teacherName: string | null;
  autoRule: string | null;
  periodKey: string | null;
  schoolYearId: string;
  schoolYearCode: string | null;
  schoolYearName: string | null;
  awardedAt: string;
  note: string | null;
  createdAt: string;
};

export type SandDollarAwardListResponse = {
  data: SandDollarAward[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
};

export type SandDollarAwardSortKey = 'date' | 'student' | 'house' | 'grade' | 'category' | 'teacher';

export type SandDollarAwardsFilters = {
  page?: number;
  limit?: number;
  studentId?: string;
  teacherUserId?: string;
  categoryId?: string;
  houseId?: string;
  gradeLevel?: number;
  from?: string;
  to?: string;
  mine?: boolean;
  auto?: boolean;
  sortBy?: SandDollarAwardSortKey;
  sortDir?: 'asc' | 'desc';
};

export const sandDollarAwardsApi = {
  list: (filters: SandDollarAwardsFilters = {}) => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.studentId) params.append('studentId', filters.studentId);
    if (filters.teacherUserId) params.append('teacherUserId', filters.teacherUserId);
    if (filters.categoryId) params.append('categoryId', filters.categoryId);
    if (filters.houseId) params.append('houseId', filters.houseId);
    if (filters.gradeLevel !== undefined) params.append('gradeLevel', String(filters.gradeLevel));
    if (filters.from) params.append('from', filters.from);
    if (filters.to) params.append('to', filters.to);
    if (filters.mine) params.append('mine', 'true');
    if (filters.auto !== undefined) params.append('auto', String(filters.auto));
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.sortDir) params.append('sortDir', filters.sortDir);
    const qs = params.toString();
    return fetchApi<SandDollarAwardListResponse>(`${SAND_DOLLAR_AWARDS_PATH}${qs ? `?${qs}` : ''}`);
  },
  create: (data: { studentId: string; categoryId: string; awardedAt?: string; note?: string }) =>
    fetchApi<SandDollarAward>(SAND_DOLLAR_AWARDS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  createBatch: (awards: { studentId: string; categoryId: string; awardedAt?: string; note?: string }[]) =>
    fetchApi<SandDollarAward[]>(`${SAND_DOLLAR_AWARDS_PATH}/batch`, {
      method: 'POST',
      body: JSON.stringify({ awards }),
    }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${SAND_DOLLAR_AWARDS_PATH}/${id}`, { method: 'DELETE' }),
};
